import { Action } from '../../framework/framework/components/Types';
import * as style from './style.css';
import classes from '../../framework/framework/tools/classes';
import React = require('react');

interface IProps {
    label: string;
    onClick: Action;
    disabled?: boolean;
}
interface IState {

}

export default class ActionButton extends React.Component<IProps, IState> {
    render() {
        const clickAction = this.props.disabled === true ? null : () => this.props.onClick();
        const disabledStyle = this.props.disabled === true ? style.disabled : '';
        return (
            <div className={classes(style.actionButton, disabledStyle)} onClick={clickAction}>
                {this.props.children}
                <span style={{ whiteSpace: 'nowrap' }} >
                    {this.props.label}
                </span>
            </div>
        );
    }
}
